/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeightUnit = exports.SubscriptionFrequency = exports.RuleType = exports.RateType = exports.PickupMethod = exports.PaymentOptionType = exports.ManualCalculationReason = exports.ItemTypeItemType = exports.FallbackReason = exports.DiscountType = exports.DataFetchType = exports.ChargeType = void 0;
var ChargeType;
(function (ChargeType) {
    ChargeType["HANDLING_FEE"] = "HANDLING_FEE";
    ChargeType["INSURANCE"] = "INSURANCE";
})(ChargeType = exports.ChargeType || (exports.ChargeType = {}));
var DataFetchType;
(function (DataFetchType) {
    DataFetchType["SHIPPING"] = "SHIPPING";
    DataFetchType["DISCOUNT"] = "DISCOUNT";
    DataFetchType["ADDITIONAL_FEES"] = "ADDITIONAL_FEES";
})(DataFetchType = exports.DataFetchType || (exports.DataFetchType = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType["GLOBAL"] = "GLOBAL";
    DiscountType["SPECIFIC_ITEMS"] = "SPECIFIC_ITEMS";
    DiscountType["SHIPPING"] = "SHIPPING";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
var FallbackReason;
(function (FallbackReason) {
    FallbackReason["AUTO_TAX_FAILED"] = "AUTO_TAX_FAILED";
    FallbackReason["AUTO_TAX_DEACTIVATED"] = "AUTO_TAX_DEACTIVATED";
})(FallbackReason = exports.FallbackReason || (exports.FallbackReason = {}));
var ItemTypeItemType;
(function (ItemTypeItemType) {
    ItemTypeItemType["UNRECOGNISED"] = "UNRECOGNISED";
    ItemTypeItemType["PHYSICAL"] = "PHYSICAL";
    ItemTypeItemType["DIGITAL"] = "DIGITAL";
    ItemTypeItemType["GIFT_CARD"] = "GIFT_CARD";
    ItemTypeItemType["SERVICE"] = "SERVICE";
})(ItemTypeItemType = exports.ItemTypeItemType || (exports.ItemTypeItemType = {}));
var ManualCalculationReason;
(function (ManualCalculationReason) {
    ManualCalculationReason["GLOBAL_SETTING_TO_MANUAL"] = "GLOBAL_SETTING_TO_MANUAL";
    ManualCalculationReason["REGION_SETTING_TO_MANUAL"] = "REGION_SETTING_TO_MANUAL";
})(ManualCalculationReason = exports.ManualCalculationReason || (exports.ManualCalculationReason = {}));
var PaymentOptionType;
(function (PaymentOptionType) {
    PaymentOptionType["FULL_PAYMENT_ONLINE"] = "FULL_PAYMENT_ONLINE";
    PaymentOptionType["FULL_PAYMENT_OFFLINE"] = "FULL_PAYMENT_OFFLINE";
    PaymentOptionType["MEMBERSHIP"] = "MEMBERSHIP";
    PaymentOptionType["DEPOSIT_ONLINE"] = "DEPOSIT_ONLINE";
    PaymentOptionType["MEMBERSHIP_OFFLINE"] = "MEMBERSHIP_OFFLINE";
})(PaymentOptionType = exports.PaymentOptionType || (exports.PaymentOptionType = {}));
var PickupMethod;
(function (PickupMethod) {
    PickupMethod["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
    PickupMethod["STORE_PICKUP"] = "STORE_PICKUP";
    PickupMethod["PICKUP_POINT"] = "PICKUP_POINT";
})(PickupMethod = exports.PickupMethod || (exports.PickupMethod = {}));
var RateType;
(function (RateType) {
    RateType["NO_TAX_COLLECTED"] = "NO_TAX_COLLECTED";
    RateType["MANUAL_RATE"] = "MANUAL_RATE";
    RateType["AUTO_RATE"] = "AUTO_RATE";
    RateType["FALLBACK_RATE"] = "FALLBACK_RATE";
})(RateType = exports.RateType || (exports.RateType = {}));
var RuleType;
(function (RuleType) {
    RuleType["VALIDATION"] = "VALIDATION";
    RuleType["OTHER"] = "OTHER";
    RuleType["MAX"] = "MAX";
    RuleType["MIN"] = "MIN";
    RuleType["MAX_LENGTH"] = "MAX_LENGTH";
    RuleType["MIN_LENGTH"] = "MIN_LENGTH";
    RuleType["MAX_SIZE"] = "MAX_SIZE";
    RuleType["MIN_SIZE"] = "MIN_SIZE";
    RuleType["FORMAT"] = "FORMAT";
    RuleType["DECIMAL_LTE"] = "DECIMAL_LTE";
    RuleType["DECIMAL_GTE"] = "DECIMAL_GTE";
    RuleType["DECIMAL_LT"] = "DECIMAL_LT";
    RuleType["DECIMAL_GT"] = "DECIMAL_GT";
    RuleType["DECIMAL_MAX_SCALE"] = "DECIMAL_MAX_SCALE";
    RuleType["INVALID_ENUM_VALUE"] = "INVALID_ENUM_VALUE";
    RuleType["REQUIRED_FIELD"] = "REQUIRED_FIELD";
    RuleType["FIELD_NOT_ALLOWED"] = "FIELD_NOT_ALLOWED";
    RuleType["ONE_OF_ALIGNMENT"] = "ONE_OF_ALIGNMENT";
})(RuleType = exports.RuleType || (exports.RuleType = {}));
var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["UNDEFINED"] = "UNDEFINED";
    SubscriptionFrequency["DAY"] = "DAY";
    SubscriptionFrequency["WEEK"] = "WEEK";
    SubscriptionFrequency["MONTH"] = "MONTH";
    SubscriptionFrequency["YEAR"] = "YEAR";
})(SubscriptionFrequency = exports.SubscriptionFrequency || (exports.SubscriptionFrequency = {}));
var WeightUnit;
(function (WeightUnit) {
    WeightUnit["UNSPECIFIED_WEIGHT_UNIT"] = "UNSPECIFIED_WEIGHT_UNIT";
    WeightUnit["KG"] = "KG";
    WeightUnit["LB"] = "LB";
})(WeightUnit = exports.WeightUnit || (exports.WeightUnit = {}));
//# sourceMappingURL=types.js.map